import reduxThunk from 'redux-thunk';
import { applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { cacheStoreMiddleware } from './cache-store';

const IS_DEV = process.env.NODE_ENV === 'development';

export const storeMiddleware = IS_DEV
  ? composeWithDevTools(applyMiddleware(reduxThunk, cacheStoreMiddleware as any))
  : applyMiddleware(reduxThunk, cacheStoreMiddleware as any);
